import { Badge, Button, Grid, Group, Menu, Modal, Paper, Stack, Text } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/auth.context';
import InputField, { InputFieldTypes } from '../components/input_field';
import Table from '../components/table';
import moment from 'moment';
import { getExtenseDatetime } from '../utility/util';
import { useLanguage } from '../contexts/language.context';
import { GET_ALL_CARS } from '../services/cars';
import { CREATE_SUPPORT, GET_ALL_SUPPORTS, UPDATE_SUPPORT } from '../services/supports';
import { showNotification } from '@mantine/notifications';
import { FaPlus } from 'react-icons/fa';

export default function MaintenancesPage() {
    const [cars, setCars] = useState<any[]>([]);
    const [supportModal, setSupportModal] = useState<any>(null);
    const [supports, setSupports] = useState<any[]>([]);
    const [filters, setFilters] = useState<any>({
        status: "all",
        period: [],
    })
    const [loadingSaveSupport, setLoadingSaveSupport] = useState<boolean>(false);
    const [loadingData, setLoadingData] = useState<boolean>(false);

    const { str } = useLanguage();

    const loadData = async () => {
        try {
            setLoadingData(true);
            setSupports(await GET_ALL_SUPPORTS());
            setCars(await GET_ALL_CARS());
        } catch (err: any) {
            showNotification({ message: err.message, color: "red" })
        } finally {
            setLoadingData(false);
        }
    }

    const saveStatus = async (supportId: string, status: number) => {
        let params = { status };
        const prev = supports;
        setSupports(cs => cs.map(c => c._id === supportId ? { ...c, status } : c))
        UPDATE_SUPPORT(supportId, params)
            .then(res => { })
            .catch(err => {
                setSupports(prev);
                showNotification({ message: err.message, color: "red" })
            })
    }


    const saveSupport = () => {
        const category = supportModal;
        if (!category._id) {
            setLoadingSaveSupport(true);
            CREATE_SUPPORT(category)
                .then(res => {
                    loadData();
                    setSupportModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveSupport(false); })
        } else {
            setLoadingSaveSupport(true);
            let params = { ...category };
            delete params._id;
            UPDATE_SUPPORT(category._id, params)
                .then(res => {
                    loadData();
                    setSupportModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveSupport(false); })
        }
    }

    useEffect(() => {
        loadData();
    }, [])

    return <>
        <Grid align='flex-end'>
            <Grid.Col span={{ md: 3 }}>
                <InputField
                    fieldType={InputFieldTypes.SELECT}
                    name="status"
                    title="Status"
                    clearable={false}
                    searchable={false}
                    value={filters.status}
                    onChange={(dt: any) => setFilters((f: any) => ({ ...f, ...dt }))}
                    options={[
                        { label: "Todas", value: "all" },
                        { label: "Agendadas", value: "1" },
                        { label: "Canceladas", value: "0" },
                        { label: "Finalizadas", value: "2" },
                        { label: "Em andamento", value: "3" },
                    ]}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 3 }}>
                <InputField
                    fieldType={InputFieldTypes.DATERANGE}
                    name="period"
                    title="Período"
                    value={filters.period}
                    onChange={(dt: any) => setFilters((f: any) => ({ ...f, ...dt }))}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 4 }}>
            </Grid.Col>
            <Grid.Col span={{ md: 2 }}>
                <Button fullWidth loading={loadingData} onClick={() => setSupportModal({ type: "maintenance" })} leftSection={<FaPlus />}>Cadastrar</Button>
            </Grid.Col>
            <Grid.Col span={{ md: 12 }}>
                <Table
                    columns={[
                        { title: "Data", key: "datetime", render: (item) => getExtenseDatetime(item.datetime) },
                        { title: "Conclusão", key: "finished_at", render: (item) => item.finished_at && getExtenseDatetime(item.finished_at) },
                        { title: "Tipo", key: "title" },
                        {
                            title: "Veículo", key: "license_plate", render: (item) => [
                                (item.car?.license_plate ?? ""),
                                (item.car?.model?.brand?.title ?? ""),
                                (item.car?.model?.title ?? ""),
                                (item.car?.model?.category?.title ?? ""),
                                str(`COLORS.${item.car?.color}`),
                                (item.car?.year ?? ""),
                            ].join(", ")
                        },
                        {
                            title: "Status", key: "status", render: (item) => (
                                <Menu>
                                    <Menu.Target>
                                        {
                                            ({
                                                "0": <Badge color="red">cancelada</Badge>,
                                                "1": <Badge color="yellow">agendada</Badge>,
                                                "2": <Badge color="green">finalizada</Badge>,
                                                "3": <Badge color="blue">em andamento</Badge>,
                                            }[item.status as string])
                                        }
                                    </Menu.Target>
                                    <Menu.Dropdown>
                                        {[1, 3].includes(item.status) && <Menu.Item
                                            onClick={() => saveStatus(item._id, 0)}
                                        >Cancelar</Menu.Item>}
                                        {[1].includes(item.status) && <Menu.Item
                                            onClick={() => saveStatus(item._id, 3)}
                                        >Iniciar</Menu.Item>}
                                        {[3].includes(item.status) && <Menu.Item
                                            onClick={() => saveStatus(item._id, 2)}
                                        >Finalizar</Menu.Item>}
                                        {[2].includes(item.status) && <Menu.Item
                                            onClick={() => saveStatus(item._id, 1)}
                                        >Voltar pra agendado</Menu.Item>}
                                    </Menu.Dropdown>
                                </Menu>
                            )
                        },
                    ]}
                    actions={[
                        { title: "Editar", onClick: ({ item }) => setSupportModal(item) }
                    ]}
                    data={supports.filter(i => (
                        (filters.status === "all" || filters.status == i.status) &&
                        (!filters.period[0] || moment(filters.period[0]).format("YYYY-MM-DD") <= moment(i.datetime).format("YYYY-MM-DD")) &&
                        (!filters.period[1] || moment(filters.period[1]).format("YYYY-MM-DD") >= moment(i.datetime).format("YYYY-MM-DD"))
                    ))}
                />
            </Grid.Col>
        </Grid>

        <Modal
            opened={!!supportModal}
            onClose={() => setSupportModal(null)}
            size="xs"
        >
            <Stack>
                <InputField
                    name="type"
                    value={supportModal?.type}
                    title="Tipo"
                    clearable={false}
                    searchable={false}
                    onChange={({ type }: any) => setSupportModal((pv: any) => ({
                        ...pv, type, title: {
                            "maintenance": "Manutenção Preventiva",
                            "legal": "Pendência Administrativa",
                            "opperation": "Pendência Operacional",
                        }[type as string]
                    }))}
                    fieldType={InputFieldTypes.SELECT}
                    options={[
                        { value: "maintenance", label: "Manutenção Preventiva" },
                        { value: "legal", label: "Pendência Administrativa" },
                        { value: "opperation", label: "Pendência Operacional" },
                    ]}
                />
                <InputField
                    name="car"
                    value={supportModal?.car?._id ?? supportModal?.car}
                    title="Veículo"
                    onChange={({ car }: any) => setSupportModal((pv: any) => ({ ...pv, car }))}
                    fieldType={InputFieldTypes.SELECT}
                    options={cars.map(b => ({ label: b.license_plate, value: b._id }))}
                />
                <InputField
                    name="datetime"
                    value={supportModal?.datetime}
                    title="Data/hora"
                    fieldType={InputFieldTypes.DATETIME}
                    onChange={({ datetime }: any) => setSupportModal((pv: any) => ({ ...pv, datetime }))}
                />

                <Group justify='flex-end'>
                    <Button
                        onClick={saveSupport}
                        loading={loadingSaveSupport}
                        disabled={!supportModal?.car || !supportModal?.datetime}
                    >Salvar</Button>
                </Group>
            </Stack>
        </Modal>
    </>
}
